<template>
  <div class="fans_box">
    <div class="box_1">
        <span>粉丝量级</span>
        <van-dropdown-menu>
        <van-dropdown-item @change="getLive" v-model="value_1" :options="fans" />
        </van-dropdown-menu>
    </div>
    <div class="box_1">
        <span>直播类型</span>
        <van-dropdown-menu>
        <van-dropdown-item @change="getLive" v-model="value_2" :options="liveType" />
          </van-dropdown-menu>
    </div>
  </div>
</template>

<script>
import {fans,liveType} from "./fansLive"
export default {
  data() {
    return {
        fans,
        liveType,
        value_1:'',
        value_2:''
    }
  },
  methods: {

    getLive(val) {
        if (this.$store.state.userLevel && this.$store.state.userLevel <= 100) {
            this.$emit('getLive',{liveType:this.value_2,fans:this.value_1})
      } else {
        setTimeout(() => {
          this.$store.commit('WRITEOVERLAYSHOW',  { status: true, textChange: 'carrierList' });
        }, 500);
      }
    }
  }
}
</script>

<style scoped lang='less'>
.fans_box {
    display: flex;
    background-color: #fff;
    align-items: center;
    height: 45px;
    width: 100vw;
    .box_1 {
        padding: 0 10px;
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 14px;
            color: #999999;
        }
    }

}
/deep/.van-dropdown-menu__item {
    height: 100% !important;
    line-height: 100% !important;
}
/deep/.van-dropdown-menu {
    height: 100% !important;
}
/deep/.van-dropdown-menu__bar {
    box-shadow: none !important;
}
/deep/.van-ellipsis {
    font-size: 14px;
}
</style>
